import SvgIcon from "@mui/material/SvgIcon";

export const GiftCheckIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      fill="none"
      viewBox="0 0 21 21">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M4.2 3.281c.338.583.92 1.089 1.629 1.471H1.164c-.309 0-.605.12-.823.335A1.13 1.13 0 0 0 0 5.893v3.041c0 .303.123.593.341.807.124.121.273.212.435.269v8.05c0 .302.123.591.341.805s.514.335.823.335h8.227a6.4 6.4 0 0 1-.858-.92v.16H1.94a.4.4 0 0 1-.273-.112.38.38 0 0 1-.114-.269v-7.984h7.757v.446c.346-.454.752-.86 1.205-1.206h-.429V5.513h7.951c.103 0 .202.04.274.111a.38.38 0 0 1 .114.269v3.041a.38.38 0 0 1-.2.333q.315.236.599.507l.036-.033a1.13 1.13 0 0 0 .341-.807V5.893a1.13 1.13 0 0 0-.341-.806 1.18 1.18 0 0 0-.823-.335h-4.47c.709-.382 1.29-.888 1.629-1.47a2.144 2.144 0 0 0-.24-2.575 2.23 2.23 0 0 0-1.188-.662A2.26 2.26 0 0 0 12.41.19c-1.25.508-2.318 1.984-2.713 3.595C9.302 2.173 8.235.698 6.985.19A2.27 2.27 0 0 0 5.627.046a2.24 2.24 0 0 0-1.219.696 2.143 2.143 0 0 0-.208 2.54m10.32-.376c-.65 1.12-2.518 1.916-4.197 1.84.132-1.649 1.17-3.36 2.384-3.853a1.45 1.45 0 0 1 1.682.336 1.375 1.375 0 0 1 .13 1.678m-5.21 6.41H1.163a.4.4 0 0 1-.275-.112.38.38 0 0 1-.113-.269V5.893c0-.101.04-.198.113-.269a.4.4 0 0 1 .275-.111h8.145zM5.004 1.228a1.397 1.397 0 0 0-.131 1.678c.65 1.12 2.51 1.917 4.197 1.84-.131-1.65-1.17-3.36-2.383-3.853a1.47 1.47 0 0 0-1.683.335"
        clipRule="evenodd"></path>
      <path
        fill="#fff"
        d="M14.207 16.128a.7.7 0 0 1-.495-.205L12.25 14.46l.33-.33 1.462 1.462a.233.233 0 0 0 .33 0l4.73-4.73.329.33-4.729 4.73a.7.7 0 0 1-.495.205"></path>
      <path
        fill="#fff"
        d="M14.576 19.942a5.367 5.367 0 1 1 2.132-10.293l.214.094-.185.428-.214-.093a4.902 4.902 0 1 0 2.934 4.055l-.02-.233.464-.043.021.234a5.364 5.364 0 0 1-5.346 5.85"></path>
      <path
        stroke="#fff"
        strokeWidth="0.208"
        d="M14.207 16.128a.7.7 0 0 1-.495-.205L12.25 14.46l.33-.33 1.462 1.462a.233.233 0 0 0 .33 0l4.73-4.73.329.33-4.729 4.73a.7.7 0 0 1-.495.205Z"></path>
      <path
        stroke="#fff"
        strokeWidth="0.208"
        d="M14.576 19.942a5.367 5.367 0 1 1 2.132-10.293l.214.094-.185.428-.214-.093a4.902 4.902 0 1 0 2.934 4.055l-.02-.233.464-.043.021.234a5.364 5.364 0 0 1-5.346 5.85Z"></path>
    </svg>
  </SvgIcon>
);
